// targetDateString 은 0000-00-00 00:00:00 형식이어야 함
export default function daysUntil(targetDateString: string): number | string {
  const targetDate = new Date(targetDateString);
  const currentDate = new Date();

  if (Number.isNaN(targetDate.getTime()) || Number.isNaN(currentDate.getTime())) {
    return '?';
  }

  const differenceInMilliseconds = targetDate.getTime() - currentDate.getTime();

  const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

  return Math.floor(differenceInDays);
}
